export var GeoShapeType;
(function (GeoShapeType) {
    GeoShapeType[GeoShapeType["Unknown"] = 100] = "Unknown";
    GeoShapeType[GeoShapeType["Point"] = 101] = "Point";
    GeoShapeType[GeoShapeType["Line"] = 102] = "Line";
    GeoShapeType[GeoShapeType["Polyline"] = 103] = "Polyline";
    GeoShapeType[GeoShapeType["Polygon"] = 104] = "Polygon";
})(GeoShapeType || (GeoShapeType = {}));
export function isGeoShape(value) {
    return value && value.type !== undefined && GeoShapeType[value.type] !== undefined;
}
//# sourceMappingURL=geography.shapes.interfaces.js.map